import { useAuth } from "../context/AuthContext";
import { MapPin } from "lucide-react";

const LocaleChooser = () => {
  const { locali, cambiaLocale, user } = useAuth();

  if (!locali || locali.length <= 1) return null;

  const nome = user?.nome || user?.email || user?.telefono || "";

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4" data-testid="locale-chooser-overlay">
      <div className="w-full max-w-sm bg-white rounded-3xl shadow-2xl overflow-hidden" data-testid="locale-chooser">
        {/* Header */}
        <div className="px-6 pt-8 pb-4 text-center">
          <div className="w-14 h-14 rounded-2xl mx-auto mb-4 flex items-center justify-center"
            style={{ background: "linear-gradient(135deg, #6C63FF 0%, #8B5CF6 100%)" }}>
            <MapPin className="h-7 w-7 text-white" />
          </div>
          <h2 className="text-xl font-black text-gray-900">
            {nome ? `Ciao ${nome.split(" ")[0]}!` : "Ciao!"}
          </h2>
          <p className="text-sm text-gray-500 mt-1">In quale locale lavori oggi?</p>
        </div>

        {/* Locale list */}
        <div className="px-4 pb-6 space-y-2.5">
          {locali.map((locale) => (
            <button
              key={locale.id}
              onClick={() => cambiaLocale(locale)}
              className="w-full flex items-center gap-4 p-4 rounded-2xl border-2 border-gray-100 hover:border-indigo-400 hover:bg-indigo-50/50 active:scale-[0.98] transition-all text-left group"
              data-testid={`locale-option-${locale.id}`}
            >
              <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0 bg-gray-100 group-hover:bg-indigo-100 transition-colors">
                <span className="text-lg font-black text-gray-400 group-hover:text-indigo-600 transition-colors">
                  {(locale.nome || "L")[0].toUpperCase()}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[15px] font-bold text-gray-900 truncate">{locale.nome}</p>
                {locale.indirizzo && (
                  <p className="text-xs text-gray-400 truncate mt-0.5">{locale.indirizzo}</p>
                )}
              </div>
              <div className="shrink-0 w-8 h-8 rounded-lg flex items-center justify-center bg-gray-50 group-hover:bg-indigo-500 transition-colors">
                <svg className="w-4 h-4 text-gray-300 group-hover:text-white transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LocaleChooser;
